module.exports = __webpack_public_path__ + "img/gravier_beton.21a60e9f.jpg";